export default __webpack_public_path__ + "static/media/brimstone_new.240ceae5.png";